export const packageList = [
  {
    name: 'call',
    activeRule: ['call2', 'callCenter', 'voiceCalls', 'voicePlatform', 'reportManage', 'qualitySystem'],
  },
]

export const remoteModuleConfig = {
  dev: ['call'],
  stg: ['call'],
  uat: ['call'],
  prd: ['call'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/call/index.js